module.exports = __webpack_public_path__ + "img/rocket.1cf0f8f4.png";